import { useQuery } from '@tanstack/vue-query'
import { marketsQueryKeys } from './marketsQueryKeys'
import { getMarkets } from './marketsEndpoints'
import { parseMarketList } from './marketParser'

export function useMarketsQuery() {
  return useQuery({
    queryKey: marketsQueryKeys.list(),
    queryFn: () => getMarkets().then(parseMarketList),
  })
}
